import React from "react";
import { Route, Routes } from "react-router-dom";
import { SubscriptionLayout } from "./SubscriptionLayout";
import { Plans } from "./Plans";
import { ManageYourSubscription } from "./ManageYourSubscription";
import { ReactivateSubscription } from "./ReactivateSubscription";

const Subscription = () => (
  <Routes>
    <Route element={<SubscriptionLayout />}>
      <Route path="plans" element={<Plans />} />
      <Route path="manageYourSubscription" element={<ManageYourSubscription />} />
      <Route path="reactivate-subscription" element={<ReactivateSubscription />} />
      <Route index element={<Plans />} />
    </Route>
  </Routes>
)

export {Subscription}